export const getCouponURL = (couponId: string) => {
  return `${window.location.origin}/customer/${couponId}`;
};
